export const Likelihood_00 = 'likelihood-00';
export const Likelihood_10 = 'likelihood-10';
export const Likelihood_20 = 'likelihood-20';
export const Likelihood_30 = 'likelihood-30';
export const Likelihood_Pathognomonic = 'likelihood-40';
export const LikelihoodValues = [Likelihood_00, Likelihood_10, Likelihood_20, Likelihood_30, Likelihood_Pathognomonic];
//# sourceMappingURL=types.js.map